import React, { useEffect, useState } from "react";
import { getWeltPage } from "../lib/api";
import {
  Page,
  PageHeader,
  Section,
  IntroSplit,
  CardGrid,
  IconCard,
} from "../components/ui";

export default function WeltAlsLernraumPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getWeltPage()
      .then((res) => !cancelled && setData(res))
      .catch((err) => !cancelled && setError(err));
    return () => {
      cancelled = true;
    };
  }, []);

  const {
    heroTitle,
    heroSubtitle,
    heroImages,
    introKicker,
    introTitle,
    introText1,
    introText2,
    cards,
  } = data || {};

  return (
    <Page loading={!data} error={error}>
      <PageHeader
        parent={{ label: "Lernwelt", to: "/lernen-und-verstehen" }}
        current="Die Welt als Lernraum"
        title={heroTitle}
        subtitle={heroSubtitle}
      />

      <Section intro>
        <IntroSplit
          images={heroImages}
          kicker={introKicker}
          title={introTitle}
          text={[introText1, introText2]}
        />
      </Section>

      <Section>
        <CardGrid cols={3}>
          {(cards || []).map((card, i) => (
            <IconCard
              key={card.id ?? i}
              iconName={card.iconName}
              title={card.title}
              text={card.text}
              headingLevel={3}
            />
          ))}
        </CardGrid>
      </Section>
    </Page>
  );
}